import { useTranslate } from '@va/localization';
import { ConfirmationDialogProps, ConfirmationModal } from '@va/shared/util-confirmation';
import { Paragraph } from '@va/ui/design-system';
import { useMemo } from 'react';

export const DeleteSenderEmailConfirmationModal: React.FC<ConfirmationDialogProps> = ({ onClose, onConfirm }) => {
  const translate = useTranslate();

  const infoNode = useMemo(() => {
    return (
      <div>
        <Paragraph>
          <Paragraph>{translate('customSenderEmail.confirmDelete.line1')}</Paragraph>
        </Paragraph>
      </div>
    );
  }, [translate]);

  return (
    <ConfirmationModal
      info={infoNode}
      title={translate('customSenderEmail.confirmDelete.title')}
      onClose={onClose}
      onConfirmation={onConfirm}
      isOpen={true}
      actionButtonText={translate('button.confirm')}
    />
  );
};
